var slick = require('slick-carousel');
var validate = require('jquery-form-validator');
var isMobile = require('ismobilejs');
var debounce = require('debounce');

var LMI = {
  common: {
    init: function() {
      if (!isMobile.any) {
        $('body').addClass('notouch');
      }
      if (isMobile.apple.device) {
        $('body').addClass('ios');
      }
    }
  },

  toDate: {
    init: function() {
      $('.homepage-carousel .panel .date').each(function() {
        if ($(this).text().length === 0) {
          $(this).hide();
        }
      });
    }
  },

  submitForm: {
    init: function() {
      // submits form data via ajax and executes callback
      var submitForm = function(e, $input, success, failure) {

        $form = $input.closest('form');
        $.ajax({
          url: $form.data('url'),
          method: 'POST',
          data: $form.serialize(),
          complete: function(result, status) {
            if (result.status.toString() === '200') {
              console.log('result.status : ' + result.status);
              console.log('result.responseJSON : ' + result.responseJSON);
              if (result.responseJSON.Success) {
                $form.addClass('hide');
                success();
              } else {
                failure('Validation of field values failed.');
              }
            } else {
              failure('There is a problem with the service.');
            }
          }
        });

      };

      // submit and callback for contact form (get started)
      $('.contact-form-submit').click(function(e) {
        $.validate({
          form: '#contactForm',
          validateOnBlur: false, // disable validation when input looses focus
          //errorMessagePosition: 'top', // Instead of 'inline' which is default
          addSuggestions: true,
          scrollToTopOnError: false, // Set this property to true on longer forms
          onSuccess: function(form) {
            $('.form-btn').prop('disabled', true);
            $('.form-btn').addClass('bt-fade');
            submitForm(e, form, function() {
              $('.form-field.hide').removeClass('hide');
            }, function(message) { alert(message); });
            return false;
          }
        });
      });

      // submit and callback for newsletter form (footer)
      $('.newsletter-form-submit').click(function(e) {
        $.validate({
          form: '#newsletterForm',
          onSuccess: function(form) {
            $('.form-btn').prop('disabled', true);
            $('').addClass('bt-fade');
            submitForm(e, form, function() {
              $('.signup').removeClass('signup').addClass('hide');
              $('.thank-you').removeClass('hide').addClass('signup');
            }, function(message) { console.log(message); });
            return false;
          }
        });
      });

      // submit and callback for resource form (resource pages, first submit)
      $('.resource-form-submit').click(function(e) {
        $.validate({
          form: '#resourceForm',
          onSuccess: function(form) {
            $('.form-btn').prop('disabled', true);
            $('').addClass('bt-fade');
            submitForm(e, form, function() {
              window.location.reload(true);
            }, function(message) { console.log(message); });
            return false;
          }
        });
      });


      // submit stored resource form data on button/video click(resource pages, subsequent submits)
      $(function() {
        if ($('#resourceForm.hide')) {
          var silverpopTracked = false;
          $(".video").click(function() {
            if (!silverpopTracked) {
              var $form = $('#resourceForm');
              $.ajax({ url: $form.data('url'), method: 'POST', data: $form.serialize() });
              silverpopTracked = true;
            }
          });
          $(".resource-download").click(function() {
            if (!silverpopTracked) {
              var $form = $('#resourceForm');
              $.ajax({ url: $form.data('url'), method: 'POST', data: $form.serialize() });
              silverpopTracked = true;
            }
          });
        }
      });


      // toggles hidden subscription checkbox on forms
      $('.toggle-subscribe').click(function(e) {
        e.preventDefault();
        if ($('.form-subscribe').hasClass('hide')) {
          $('.form-subscribe').removeClass('hide');
        } else {
          $('.form-subscribe').addClass('hide');
        }
      });

      // handles checkbox value setting
      $('#checkbox-subscribe').change(function() {
        $('#subscribe').val($(this).is(':checked') ? '1' : '0');
      });


      // toggles state dropdown on forms
      $('#country').change(function(e) {
        if ($(this).val() === "US") {
          $('#state').parent('div').removeClass('hide');
        } else {
          $('#state').parent('div').addClass('hide');
        }
      });
    }
  },

  sortResurces: {
    init: function() {
      $('ul.sub-nav li').click(function() {
        if (screen.width < 770) {
          $('.sub-nav').addClass("hide");
        }
        $(".l-item").removeClass('hide');
        $(".l-item").removeClass('show');
        $('.sub-nav li').removeClass('current');
        var sort_id = $(this).attr('data-sort').toLowerCase();
        if (sort_id === "all") {
          $(this).addClass('current');
          $(".l-item").removeClass('hide');
        } else {
          $(this).addClass('current');
          $(".l-item").removeClass('hide');
          $(".l-item").removeClass('show');
          $('.l-item[data-filter=' + sort_id + ']').addClass('show');
          $('.l-item[data-filter!=' + sort_id + ']').addClass('hide');
        }
      });
    }
  },

  scrubUrl: {
    init: function() {
      //console.log("scrubURL");
      $.urlParam = function(name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results != null) {
          return results[1] || 0;
        }
      };

      var key = '',
        view = '',
        $target = '';
      $.each(['a', 'n', 'p', 'r'], function(i, v) {
        return typeof(view = $.urlParam(key = v)) === 'undefined';
      });

      if (key === 'a' || key === 'p') {
        $target = $('.modal').find('.window[data-modal="' + view + '"]');
        if ($target.length) {
          $target.show();
          $('.modal').show();
        }

      } else if (key === 'n') {
        $target = $('li[data-tab="' + view + '"]');
        if ($target.length) {
          $('ul.tabs li').removeClass('current');
          $('.tab-content').removeClass('current');
          $target.addClass('current');
          $('#' + view).addClass('current');
          $("#tab-anchor")[0].click();
        }
      } else if (key === 'r') {
        $target = $('.l-item[data-filter=' + view + ']');
        if ($target.length) {
          $('.sub-nav li').removeClass('current');
          $('.sub-nav li[data-sort=' + view + ']').addClass('current');
          $(".l-item").removeClass('hide');
          $('.l-item[data-filter=' + view + ']').addClass('show');
          $('.l-item[data-filter!=' + view + ']').addClass('hide');
        }
      }
    }
  },

  tabs: {
    init: function() {
      $('ul.tabs li').click(function() {
        var tab_id = $(this).attr('data-tab');
        $('ul.tabs li').removeClass('current');
        $('.tab-content').removeClass('current');
        $(this).addClass('current');
        $("#" + tab_id).addClass('current');
      });
    }
  },

  resourceList: {
    init: function() {
      if (screen.width < 770) {
        $('.sub-nav').addClass("hide");
        $('.resource-nav li').click(function() {
          $(this).toggleClass("arrow-up");
          $('.sub-nav').toggleClass("hide");
        });
      }
    }
  },

  modal: {
    init: function() {
      $('.modal').hide();
      $('.listing-block, .third, .forth').click(function() {
        $('.modal').show();
        var ourDataAttr = $(this).data('modal');
        $('.modal').find('.window[data-modal="' + ourDataAttr + '"]').show();
        $('.modal').find('.window:not([data-modal="' + ourDataAttr + '"])').hide();
      });

      $('.close').click(function() {
        $('.modal').hide();
      });

      $('.modal').click(function(e) {
        var clicked = $(e.target);
        if (clicked.is('.window') || clicked.parents().is('.modal')) {
          return;
        }
      });
    }
  },

  scrollTo: {
    init: function() {
      function scrollToAnchor(aid) {
        var aTag = $("div[name='" + aid + "']");
        $('html,body').animate({ scrollTop: aTag.offset().top }, 'slow');
      }

      $("#arrow-down").click(function() {
        scrollToAnchor('arrow-target');
      });
    }
  },

  homepageanimation: {
    init: function() {
      //Take first list item and append to end of list - creating cycle
      function reorder() {
        $('.iot-items.desktop-banner').find('li').first().appendTo('.iot-items.desktop-banner');
        $('.iot-imgs.desktop-banner').find('li').first().appendTo('.iot-imgs.desktop-banner');
        $('.iot-items.mobile-banner').find('li').first().appendTo('.iot-items.mobile-banner');
        $('.iot-imgs.mobile-banner').find('li').first().appendTo('.iot-imgs.mobile-banner');
      }
      //On click scroll down when banner is taking up the full screen height and width @ mobile
      $('.scroll-down').click(function() {
        $("html, body").animate({ scrollTop: $('header + *').offset().top - 100 }, 1000);
      });
      reorder();
      setInterval(reorder, 3000);
    }
  },

  carousel: {
    init: function() {
      $('.case-study-carousel').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [{
          breakpoint: 768,
          settings: {
            dots: false,
            arrows: false,
          }
        }]
      });
      $('.homepage-carousel').slick({
        dots: false,
        infinite: true,
        fade: false,
        speed: 300,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [{
          breakpoint: 991,
          settings: {
            dots: true,
            arrows: false,
          }
        }]
      });
      $('.homepage-logo-carousel').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        initialSlide: 3,
        responsive: [{
          breakpoint: 992,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }]
      });
    }
  },

  stickyNav: {
    init: function() {
      var stickyNavTop = 42, //$('.main-menu-wrapper').offset().top,
        mainMenu = $('.main-menu'),
        mainMenuSelector = $('.main-menu > ul > li');

      $('.main-menu-wrapper').removeClass('sticky');

      var stickyNav = function() {
        var scrollTop = $(window).scrollTop();

        if (scrollTop > stickyNavTop || stickyNavTop > 72) {
          //console.log("scrollTop : "+scrollTop+ " > stickyNavTop "+stickyNavTop+" or stickyNavTop "+stickyNavTop+ " > 72?");
          $('.main-menu-wrapper').addClass('sticky');
        } else {
          $('.main-menu-wrapper').removeClass('sticky');
        }
      };

      $('header').on('mousewheel', function(e) {
        e.preventDefault();
      });

      stickyNav();

      $(window).scroll(function() {
        stickyNav();
      });


      $('.mobile-menu').on('click', '.mobile-menu-icon', function(e) {
        e.stopImmediatePropagation();
        $('.off-canvas').addClass('open');

      });

      mainMenu.on('click', '.close-menu', function(e) {
        e.stopImmediatePropagation();
        $('.off-canvas').removeClass('open');

      });

      var bindNav = function() {
        if (!isMobile.any && $(window).width() > 1025) {
          mainMenuSelector.on('mouseover', function() {
            $('.sub-nav', this).show();
          }).on('mouseout', function() {
            $('.sub-nav', this).hide();
          });
        } else if (isMobile.any || $(window).width() < 1025) {
          mainMenuSelector.off('mouseover').off('mouseout');
          mainMenuSelector.on('click', function(e) {
            e.stopImmediatePropagation();
            if ($(window).width() >= 1025) {
              $('.sub-nav', this).toggle().hide();
            } else {
              $('.sub-nav', this).not('.mobile-nodisplay').toggle();
            }
            $(this).find($(".fa")).toggleClass('up');
            $(this).siblings().children('.sub-nav').hide();
          });
        }
      };
      bindNav();
      window.onresize = debounce(bindNav, 100);
    }
  } // end stickyNav
};

var Modules = {
  fire: function(func, funcname, args) {
    var ns = LMI;
    funcname = (funcname === undefined) ? 'init' : funcname;
    if (func !== '' && ns[func] && typeof ns[func][funcname] === 'function') {
      ns[func][funcname](args);
    }
  },

  loadEvents: function() {
    //fire common functions first
    Modules.fire('common');

    //find modules to load based on data attributes
    var moduleTrigger = $('[data-module]');

    if (moduleTrigger.length) {

      var moduleNames = [];
      var modules = [];

      //find the names of each trigger
      moduleTrigger.each(function() {
        moduleNames.push($(this).data("module"));
      });

      //sort out duplicates
      for (var i = 0; i < moduleNames.length; i++) {
        if (($.inArray(moduleNames[i], modules)) === -1) {
          modules.push(moduleNames[i]);
        }
      }

      //load function based on data attribute value as names
      $.each(modules, function(i, classnm) {
        Modules.fire(classnm);
      });
    }
  }
}; // end modules

$(document).ready(Modules.loadEvents);



/** WEBPACK FOOTER **
 ** ./app/scripts/app.js
 **/